import {
    ApplicationSubmitToDecisionGate,
    StatusContainer,
} from '@servicetitan/financing-utils-shared';
import { LoanDetails } from './LoanDetails';
import ApprovedIllustration from '../../common/illustrations/checkmark-success.svg';

export const CounterOffer = () => {
    return (
        <ApplicationSubmitToDecisionGate>
            <StatusContainer
                headline="Congratulations! Your loan application was approved."
                message="You have been approved for different terms than you requested. Review your loan details and continue to sign and accept the offer."
                image={ApprovedIllustration}
            >
                <LoanDetails />
            </StatusContainer>
        </ApplicationSubmitToDecisionGate>
    );
};
